export const ChartTooltip = ({ active, payload, label, labelFormatter, valueFormatter, items }) => {
  if (!active || !payload?.length) return null;
  const rows = items ? items(payload) : payload;
  return (
    <div className='wm-chart-tooltip'>
      {label != null && (
        <div className='wm-chart-tooltip__title'>{labelFormatter ? labelFormatter(label, payload) : label}</div>
      )}
      {rows.map((row, i) => (
        <div className='wm-chart-tooltip__row' key={`${row.dataKey ?? row.name}-${i}`}>
          <span>
            <i
              className='wm-swatch'
              style={{ background: row.color ?? row.payload?.fill ?? row.stroke }}
            />
            {row.name}
          </span>
          <strong>{valueFormatter ? valueFormatter(row.value, row) : row.value}</strong>
        </div>
      ))}
    </div>
  );
};
